import { createSlice } from "@reduxjs/toolkit";

// Platform selection scoped to the ECR Ops Portal (/ecr-ops/*) — kept separate
// from `platformSlice` so switching platform here doesn't affect what the
// Home Dashboard shows, and vice versa.
const initialState = {
  selectedPlatformId: null, // null means use default (deloitte-global)
  platformName: null,
};

export const ecrOpsPlatformSlice = createSlice({
  name: "ecrOpsPlatform",
  initialState,
  reducers: {
    setEcrOpsSelectedPlatform: (state, action) => {
      state.selectedPlatformId = action.payload.platformId;
      state.platformName = action.payload.platformName;
    },
    clearEcrOpsSelectedPlatform: (state) => {
      state.selectedPlatformId = null;
      state.platformName = null;
    },
  },
});

export const { setEcrOpsSelectedPlatform, clearEcrOpsSelectedPlatform } = ecrOpsPlatformSlice.actions;
